import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ProjectInvoiceHistoryWrapper = styled.div`
  .total-invoice-amount-label {
    margin: 16px;
    ${responsive.MOBILE`
        margin: 0px 8px 16px 8px;
    `}
  }
  .nowrap-amount {
    ${responsive.MOBILE`
      white-space: nowrap;
    `}
  }
`;
